<template>
    <div :class="stepWrapperClasses" :key="step">
        <h5 class="step-field-heading">
        <span class="las back" v-if="showPrev" @click="back()">
        <img src="../../assets/arrow_back-24px.svg" >
        </span><span class="step-field-heading-text">Select Event</span></h5>
        <div v-if="eventsLoaded" class="step-fields-body step-fields-list-box event-wrapper">
            <event-row
            v-for="item in stepData.event"
            :key="item.id"
            :value="value"
            :item="item"
            :allowSelect="true"
            v-on:filled-out="addEventBookingDetails($event)"></event-row>
        </div>
        <div v-else-if="eventsEmpty" class="alert alert-primary">
            Sorry! No events available at this location.
        </div>
        <div v-else class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex';
  import axios from 'axios';
  import EventRow from './EventRow';
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    data() {
        return {
            cancelToken: ''
        }
    },
    props: {
      field: {},
      details: {},
      value: '',
      index: '',
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'nextStep',
          'prevStep',
          'setGlobalDateForDatePicker',
          'setStepData'// referenced in the mixin
        ]),
        async loadEvents(token) {
            var response;
            var params = {
                params: this.getParams(),
                cancelToken: token
            };
            response = await axios.get(`${this.domain}/forms/api/v1/forms/${this.formId}/integrations/scheduling/api/events`, params);
            this.setCurrentStepData(response.data);
        },
        back() {
            this.prevStep();
            this.cancelToken.cancel();
        },
        getParams() {
            return {
                'location' : this.bookingDetails.location.id
            }
        },
        addEventBookingDetails(value) {
            let event = this.getEventById(value);
            let oldEvent = this.bookingDetails.event;
            this.setGlobalDateForDatePicker(new Date(event.nextEvent.replace(' ', 'T')));
            this.addBookingDetails({
                'type' : 'event',
                'details' : event
            });
            this.nextStep();
            if (!oldEvent || oldEvent.id != event.id) {
                this.resetStepData();
            }
            this.$emit('filled-out',event);
        },
        getEventById(id) {
            let events = this.stepData.event.filter(event => event.id == id);
            if (events[0]) {
                return events[0];
            } else {
                return {};
            }
        }
    },
    created() {
        if (!this.eventsLoaded) {
            this.cancelToken = axios.CancelToken.source();
            this.loadEvents(this.cancelToken.token);
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
          'domain'
        ]),
        ...mapState('form', { form: 'form', formId: 'formId' }),
        ...mapState('scheduling', { step: 'step', stepData: 'stepData', bookingDetails: 'bookingDetails' }),
        eventsLoaded() {
            return this.stepData.event !== '' && !this.eventsEmpty;
        },
        eventsEmpty() {
            return Array.isArray(this.stepData.event) && this.stepData.event.length == 0;
        },
        showPrev() {
            return this.isNotFirstStep
                && (!this.form.hasOwnProperty('location')
                || this.form.location === ''
                || this.form.location === null);
        }
    },
    components: {
        EventRow,
    },
  };
</script>
